import { render } from "./ActiveCallDialogButton.vue?vue&type=template&id=8f64350e&scoped=true"
import script from "./ActiveCallDialogButton.vue?vue&type=script&lang=js"
export * from "./ActiveCallDialogButton.vue?vue&type=script&lang=js"

import "./ActiveCallDialogButton.vue?vue&type=style&index=0&id=8f64350e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f64350e"]])

export default __exports__